<template lang="pug">
</template>

<script>
import { ConfigsModuleMapper } from '@/store/modules/config';

export default {
  name: 'Main',
  layout: 'default',
  created() {
    this.$router.replace({
      path: `${this.defaultPageUrl}`,
    });
  },
  computed: {
    ...ConfigsModuleMapper.mapGetters(['configIsLoaded', 'defaultPageUrl']),
  },
};
</script>

<style lang="scss" scoped>
</style>
